<template>
    <v-dialog
        v-model="editImageDialog"
        persistent
        width="500"
        scrollable
        :fullscreen="this.$vuetify.breakpoint.xsOnly"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-icon
                class="material-icons-outlined"
                :disabled="disabled"
                :class="{'mr-2': $vuetify.breakpoint.xs}"
                v-bind="attrs"
                @click="openModel"
            >
                edit
            </v-icon>
        </template>
        <v-card id="response-dialog">
            <v-card-title>
                Edit Image Properties
            </v-card-title>
            <v-divider />
            <v-card-text 
                ref="cardText"
                class="pt-3"
            >
                <v-form
                    ref="form"
                >
                    <v-text-field
                        v-model="caption"
                        label="Caption"
                        outlined
                    />
                    <v-textarea
                        v-model="comment"
                        outlined
                        label="Comment"
                    />
                    <v-select
                        v-model="member_code"
                        :items="memberCodeList"
                        item-text="member_code"
                        item-value="member_code"
                        outlined
                        label="Code"
                    />
                </v-form>
            </v-card-text>
            <v-divider />
            <v-card-actions class="px-6 py-2">
                <v-spacer />
                <v-btn
                    style="text-transform: none !important"
                    class="text-subtitle-2"
                    outlined
                    :width="this.$vuetify.breakpoint.xs ? '140px' : '76px'"
                    @click="closeModel"
                >
                    Cancel
                </v-btn>
                <v-btn
                    style="text-transform: none !important"
                    class="text-subtitle-2"
                    :disabled="!formValid"
                    depressed
                    color="primary"
                    :width="this.$vuetify.breakpoint.xs ? '140px' : '76px'"
                    @click="editImage"
                >
                    Update
                </v-btn>
                <v-spacer v-if="this.$vuetify.breakpoint.xs" />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import webtmsBackend from '../../services/webtmsBackend';

export default {
    props: {
        row: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            required: true,
        }
    },
    data: () => ({
        editImageDialog: false,
        formValid: true,
        uploadProgress: 0,
        rowid: '',
        revision: '',
        member_code: '',
        caption: '',
        comment: '',
        visible: '',
    }),
    computed: {
        memberCodeList() {
            return this.$store.getters.ticketDetails.Ticket_Responses;
        },
        getTicketDetails() {
            return this.$store.getters.ticketDetails;
        },
        getUser() {
            return this.$store.getters.user;
        }
    },
    watch: {
        caption() {
            this.validateForm();
        },
        comment() {
            this.validateForm();
        },
        member_code() {
            this.validateForm();
        }
    },
    mounted() {
        this.rowid = this.row.rowid;
        this.revision = this.row.revision;
        this.member_code = this.row.member_code;
        this.caption = this.row.caption;
        this.comment = this.row.comment;
        this.visible = this.row.visible;
    },
    methods: {
        openModel() {
            this.editImageDialog = true;
        },
        closeModel() {
            this.member_code = this.row.member_code;
            this.caption = this.row.caption;
            this.comment = this.row.comment;
            this.editImageDialog = false;
        },
        async editImage() {
            const payload = {
                operation: 'update',
                rowid: this.rowid,
                revision: this.revision,
                member_code: this.member_code,
                caption: this.caption,
                comment: this.comment,
                visible: this.visible,
                offline: this.row.offline || undefined,
                __TIMESTAMP__: new Date().getTime(),
            };
            await webtmsBackend.editImage(payload);
            this.$emit('load-ticket-details');
            this.closeModel();
        },
        validateForm() {
            this.formValid = this.caption.trim() !== '' && this.comment.trim() !== '' && this.member_code.trim() !== '';
        }
    }
};
</script>